import { registry } from "../../../../configs/registry";
const UFRN_LIKE_ID = "app_ufrn";
const SERP_LIKE_ID = "app_serp";
export const ROUTER_ITEMS = registry
    .getApplicationByPath()
    .map(([path, { id }]) => ({
    id,
    key: path,
    path,
}))
    .sort((a, b) => {
    // Unified Frontend examples first.
    if (a.id.startsWith(UFRN_LIKE_ID) && !b.id.startsWith(UFRN_LIKE_ID)) {
        return -1;
    }
    if (!a.id.startsWith(UFRN_LIKE_ID) && b.id.startsWith(UFRN_LIKE_ID)) {
        return 1;
    }
    // Dozens of SERP URL last to reduce noise.
    if (a.id.startsWith(SERP_LIKE_ID) && !b.id.startsWith(SERP_LIKE_ID)) {
        return 1;
    }
    if (!a.id.startsWith(SERP_LIKE_ID) && b.id.startsWith(SERP_LIKE_ID)) {
        return -1;
    }
    // Sort by ID.
    if (a.id != b.id) {
        return a.id < b.id ? -1 : 1;
    }
    // Sort by link.
    return a.path < b.path ? -1 : 1;
});
